import { render, staticRenderFns } from "./Manage-Vehicle-Model.vue?vue&type=template&id=16cb930e"
import script from "./Manage-Vehicle-Model.vue?vue&type=script&lang=js"
export * from "./Manage-Vehicle-Model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports